import React from 'react';

const AboutSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/2">
            <div className="mb-6">
              <span className="text-primary font-semibold uppercase tracking-wider">
                ABOUT OUR COMPANY
              </span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-gray-900">
              We want to bring business and the digital world together
            </h2>
            <p className="text-gray-600 text-lg mb-8">
              Business tailored IT design, management & support services business agency elit, sed do eiusmod tempor.
            </p>
            <button className="bg-primary hover:bg-primary/90 text-white px-8 py-4 rounded-full font-semibold transition-all">
              Get Started Now
            </button>
          </div>
          
          <div className="lg:w-1/2 grid grid-cols-2 gap-8">
            <div className="text-center p-8 bg-gray-50 rounded-lg">
              <h3 className="text-5xl font-bold text-primary mb-2">15+</h3>
              <p className="text-gray-600">Years on the market</p>
            </div>
            <div className="text-center p-8 bg-gray-50 rounded-lg">
              <h3 className="text-5xl font-bold text-primary mb-2">250+</h3>
              <p className="text-gray-600">Projects delivered so far</p>
            </div>
            <div className="text-center p-8 bg-gray-50 rounded-lg">
              <h3 className="text-5xl font-bold text-primary mb-2">50+</h3>
              <p className="text-gray-600">Team members</p>
            </div>
            <div className="text-center p-8 bg-gray-50 rounded-lg">
              <h3 className="text-5xl font-bold text-primary mb-2">100%</h3>
              <p className="text-gray-600">Client satisfaction</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 